import React, { useEffect, useRef, useState, useLayoutEffect, useContext } from 'react'
import { Col, Container, Form, InputGroup, Row } from 'react-bootstrap'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons'
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import { ThemeContext } from '../../../context/theme-context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from "react-redux";

import lodash, { findIndex, set } from 'lodash';
import NumberFormatter from '../../../formatters/NumberFormatter';
import { DividendApi } from "../../../services/dividend/api";
import { Configuration } from "../../../services/dividend/configuration";
import './dividendCharts.scss';
import { APIControl } from '../../../helpers/APIControl';

const DividendGraphs = (props) => { // props: {modalVisible, symbol, dividendAnalysisChartData, selectedEquity}
    const api = new DividendApi(new Configuration({ basePath: process.env.REACT_APP_DIVIDEND_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_DIVIDEND_API_BASE_PATH));
    const numberFormatter = new NumberFormatter();
    const token = useSelector((state) => state.auth?.token);
    const [theme, setTheme] = useState('dark'); // ['dark', 'light'
    const currentTheme = useContext(ThemeContext).theme;
    const [visible, setVisible] = useState(false);
    const [dividendAnalysisType, setDividendAnalysisType] = useState('analysis');
    const [chartData, setChartData] = useState([]);
    const [chartDataTwo, setChartDataTwo] = useState([]);
    const [selectedEquity, setSelectedEquity] = useState("");
    let seriesProperties = [];
    let seriesBar;
    let seriesBullet;
    let chart;
    var data = [{
        "year": "2021",
        "europe": 2.5,
        "namerica": 2.5,
        "asia": 2.1,
        "lamerica": 1,
        "meast": 0.8,
        "africa": 0.4
    }, {
        "year": "2022",
        "europe": 2.6,
        "namerica": 2.7,
        "asia": 2.2,
        "lamerica": 0.5,
        "meast": 0.4,
        "africa": 0.3
    }, {
        "year": "2023",
        "europe": 2.8,
        "namerica": 2.9,
        "asia": 2.4,
        "lamerica": 0.3,
        "meast": 0.9,
        "africa": 0.5
    }]

    useEffect(() => {
        setDividendAnalysisType('analysis');
    }, [])


    useEffect(() => {
        if (props.modalVisible) {
            handleShow();
        }
    }, [props.modalVisible]);

    useEffect(() => {
        if (props.symbol && props.symbol !== '') {
            
            populateChartData();
        }
    }, [props.symbol]);




    useEffect(() => {
        setTheme(currentTheme);
        setVisible(props.modalVisible)

        if (dividendAnalysisType === 'analysis') {
            if (chartData && chartData.data?.length > 0) {
                setTimeout(() => {
                    createChart(chartData.data);
                }, 500);
            }
        }
        else if (dividendAnalysisType === 'amaount') {
            if (chartDataTwo && chartDataTwo.data?.length > 0) {
                setTimeout(() => {
                    createChart(chartDataTwo.data);
                }, 500);
            }
        }

        // if (props.chartData && props.chartData.data?.length > 0) {
        //     setTimeout(() => {
        //         createChart(props.chartData.data);
        //     }, 500);
        // }
        // if (props.chartDataTwo && props.chartDataTwo.data?.length > 0) {
        //     setTimeout(() => {
        //         if (document.getElementById('chartdivtwo')) {
        //             createChartTwo(props.chartDataTwo.data);
        //         }
        //     }, 500);
        // }
    }, [chartData, chartDataTwo, theme, dividendAnalysisType])

    const handleClose = () => {
        setVisible(false)
        props.closeModal()
    };
    const handleShow = () => {
        setVisible(true);
        // setDividendAnalysisType('analysis');
    }

    const dividendAnalysisTypeChange = (e) => {
        setDividendAnalysisType(e);
        
        // if (e === 'amaount') {
        //     setTimeout(() => {
        //         createChart(props.chartDataTwo.data);
        //     }, 500);
        // }
        // else if (e === 'analysis') {
        //     setTimeout(() => {
        //         createChart(props.chartData.data);
        //     }, 500);
        // }
        // props.modalDataChange(e)
    };

    const createChart = (data) => {



        am5.array.each(am5.registry.rootElements,
            function (root) {
                if (root.dom.id == "chartdiv") {
                    root.dispose();
                }
            }
        );
        var root = am5.Root.new("chartdiv");
        root.numberFormatter.set("numberFormat", "#,###.");
        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        chart = root.container.children.push(am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            wheelX: "panX",
            wheelY: "zoomX",
            layout: root.verticalLayout,
            maxTooltipDistance: 0,
            maxTooltipDistanceBy: "x"

        }));





        var xRenderer = am5xy.AxisRendererX.new(root, {
            cellStartLocation: 0.1,
            cellEndLocation: 0.9,
            minorGridEnabled: true
        })

        xRenderer.grid.template.setAll({
            location: 1
        })


        //#region Legend 
        var legend = chart.children.push(
            am5.Legend.new(root, {
                centerX: am5.p50,
                centerY: am5.p50,
                x: am5.p50,
                // y: am5.p50,
            })
        );
        legend.labels.template.setAll({
            fontSize: 14, // Font boyutunu burada ayarlayın
            fontFamily: 'Roboto-Medium',
            fill: theme === 'dark' ? am5.color('#fff') : am5.color('#231F20'),
        });
        //#endregion Legend

        //#region X Axis and Y Axis

        var xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
            categoryField: "period",
            tooltip: am5.Tooltip.new(root, {}),
            renderer: xRenderer
        }));

        // minGridDistance özelliğini set metodu ile ayarlayın
        xAxis.get("renderer").set("minGridDistance", 50);


        // var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
        //     renderer: am5xy.AxisRendererY.new(root, {
        //         strokeOpacity: 0.1,
        //         inversed: false,
        //         // cellStartLocation: 0.1,
        //         // cellEndLocation: 0.9,
        //         // minGridDistance: 30,
        //     })
        // }));

        var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            maxPrecision: 0,
            renderer: am5xy.AxisRendererY.new(root, {
                inversed: false
            })
        }));
        //#endregion X Axis and Y Axis

        //#region X Axis and Y Axis TITLES 

        var yAxisTitle = yAxis.children.push(am5.Label.new(root, {
            text: "Miktar (mTL)",
            rotation: -90, // Başlığı dikey yapmak için
            centerX: am5.percent(100),
            centerY: am5.percent(50),
            fontWeight: "bold",
            fontSize: 15,
            fill: theme === 'dark' ? am5.color('#fff') : am5.color('#231F20'),
        }));

        // Eksen başlığının konumunu ayarlayın 
        yAxisTitle.setAll({
            y: am5.percent(50),
            x: am5.percent(-15),
            centerX: am5.p50,
            rotation: -90
        });
        xAxis.data.setAll(data);

        // İlk olarak, mevcut Y ekseni için yapılanların benzerini yaparak yeni bir eksen oluşturun
        var yAxisRight = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            renderer: am5xy.AxisRendererY.new(root, { opposite: true }), // Karşı tarafa yerleştir
            // Diğer eksen ayarları

        }));


        // Yeni eksen için bir başlık ekleyin
        var yAxisRightTitle = yAxisRight.children.push(am5.Label.new(root, {
            text: dividendAnalysisType === 'analysis' ? "Temettü Oranı (%)" : "Temettü Verimi (%)",
            rotation: -90, // Başlığı dikey yapmak için
            centerX: am5.percent(100),
            centerY: am5.percent(50),
            fontWeight: "bold",
            fontSize: 15,
            fill: theme === 'dark' ? am5.color('#fff') : am5.color('#231F20'),

        }));

        // Eksen başlığının konumunu ayarlayın (gerekirse)
        yAxisRightTitle.setAll({
            y: am5.percent(50),
            x: am5.percent(-15),
            centerX: am5.p50,
            rotation: 90
        });


        //#endregion X Axis and Y Axis TITLES

        //#region X Axis and Y Axis LABELS
        yAxis.get("renderer").labels.template.setAll({
            oversizedBehavior: "wrap",
            maxWidth: props.hideLabel === false ? 0 : 250,
            textAlign: "center",
            fontSize: 14,
            fontFamily: 'Roboto-Medium',
            fill: theme === 'dark' ? am5.color('#fff') : am5.color('#231F20'),
        });
        yAxis.set("numberFormat", "#,###.");

        xAxis.get("renderer").labels.template.setAll({
            oversizedBehavior: "wrap",
            // maxWidth değerini kaldırabilir veya yükseltebilirsiniz
            textAlign: "center",
            fontSize: 14,
            fontFamily: 'Roboto-Medium',
            fill: theme === 'dark' ? am5.color('#fff') : am5.color('#231F20'),
        });

        //#endregion X Axis and Y Axis LABELS

        //#region Tablo arkası grid ayarları
        yAxis.get("renderer").grid.template.setAll({
            strokeOpacity: 1,
            stroke: theme === 'dark' ? am5.color('#626262') : am5.color('#E4E4E4'),
            strokeDasharray: [4, 4],
        });

        xAxis.get("renderer").grid.template.setAll({
            strokeOpacity: 0,
            stroke: theme === 'dark' ? am5.color('#626262') : am5.color('#E4E4E4'),
            strokeDasharray: [4, 4],
        });
        //#endregion Tablo arkası grid ayarları

        //#region Pareto Axis

        var paretoAxisRenderer = am5xy.AxisRendererY.new(root, { opposite: true });
        var paretoAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
            renderer: paretoAxisRenderer,
            min: 0,
            max: dividendAnalysisType === 'analysis' ? 130 : 14,
            // strictMinMax: true,
        }));

        paretoAxis.get("renderer").labels.template.setAll({
            oversizedBehavior: "wrap",
            // maxWidth: props.hideLabel === false ? 0 : 250,
            textAlign: "center",
            fontSize: 14,
            fontFamily: 'Roboto-Medium',
            fill: theme === 'dark' ? am5.color('#fff') : am5.color('#231F20'),
        });

        paretoAxisRenderer.grid.template.set("forceHidden", true);
        // paretoAxis.set("numberFormat", "#,###.000");

        //#endregion Pareto Axis

        //#region COLUMN SERIES
        // var tooltipHTML = createTooltipHTML(theme);

        let tooltipLineSeries = am5.Tooltip.new(root, {
            keepTargetHover: true,
            // labelText: "[bold]{Date.formatDate('dd/MM/yyyy')}[/]\nFiyat: {valueY}\nHacim: {Volume}",
            getFillFromSprite: false,
            getStrokeFromSprite: false,
            autoTextColor: false,
            getLabelFillFromSprite: false,
            fill: am5.color("#333"),
        });

        tooltipLineSeries.get("background").setAll({
            fill: am5.color("#333"),
            fillOpacity: 0,
            strokeOpacity: 0,
            getStrokeFromSprite: false,
        });
        tooltipLineSeries.label.set("fill", am5.color("#231f20")); // Beyaz
        let index = 0;

        const makeSeries = (name, fieldName, color) => {
            index += 1;

            seriesBar = chart.series.push(am5xy.ColumnSeries.new(root, {
                name: name,
                xAxis: xAxis,
                yAxis: yAxis,
                valueYField: fieldName,
                categoryXField: "period",
                stroke: am5.color(color),
                fill: am5.color(color),
                snapTooltip: true
            }));

            seriesProperties.push({ name, fieldName, seriesBar });

            seriesBar.bullets.push(function () {
                return am5.Bullet.new(root, {
                    centerY: am5.percent(50),
                    locationY: 0, // Bu, bullet'ların y ekseninde daha yukarıya taşınmasını sağlar
                    sprite: am5.Label.new(root, {
                        // text: "{valueY}",
                        fill: am5.color(color),
                        centerY: am5.percent(50),
                        centerX: am5.percent(50),

                        // populateText: true
                    })
                });
            });

            seriesBar.bullets.push(function () {
                return am5.Bullet.new(root, {
                    locationY: 1,
                    sprite: am5.Label.new(root, {
                        text: "{valueYWorking.formatNumber('#,###.')}",
                        fill: theme === 'dark' ? am5.color('#ffff') : am5.color('#0000'),
                        centerY: 0,
                        centerX: am5.p50,
                        populateText: true,
                        fontFamily: 'Roboto-Medium',
                        fontSize: 14,
                        dy: -25,
                    })
                });
            });

            seriesBar.data.setAll(data);
            seriesBar.appear();

            yAxis.set("numberFormat", "#,###.");
            legend.data.push(seriesBar);
        }
        //#endregion COLUMN SERIES
        var cursor = chart.set("cursor",
            am5xy.XYCursor.new(root, {
                behavior: "zoomX",
                snapToSeriesBy: "x",
                arrangeTooltips: true,
                xAxis: xAxis,
                alwaysShow: true

            }));
        // cursor.lineY.set("visible", true);


        //#region BULLET  Pareto SERIES
        let tooltipBulletSeries = am5.Tooltip.new(root, {
            keepTargetHover: true,
            // labelText: "[bold]{Date.formatDate('dd/MM/yyyy')}[/]\nFiyat: {valueY}\nHacim: {Volume}",
            getFillFromSprite: false,
            getStrokeFromSprite: false,
            autoTextColor: false,
            getLabelFillFromSprite: false,
            fill: am5.color("#333"),
        });

        tooltipBulletSeries.get("background").setAll({
            fill: am5.color("#333"),
            fillOpacity: 0,
            strokeOpacity: 0,
            getStrokeFromSprite: false,
        });
        tooltipBulletSeries.label.set("fill", am5.color("#231f20")); // Beyaz
        const makeBulletsSeries = (name, fieldName, color) => {

            seriesBullet = chart.series.push(am5xy.LineSeries.new(root, {
                name: name,
                xAxis: xAxis,
                yAxis: paretoAxis,
                valueYField: fieldName,
                categoryXField: "period",
                stroke: theme === 'dark' ? am5.color(color) : am5.color(color),
                fill: theme === 'dark' ? am5.color(color) : am5.color(color),
                snapTooltip: true,
                showTooltipOn: "always",
                tooltip: tooltipBulletSeries
            }));

            seriesBullet.bullets.push(function () {
                return am5.Bullet.new(root, {
                    centerY: am5.percent(50),
                    locationY: 0, // Bu, yatay çizgiler için bullet'ın y eksenindeki konumunu ayarlar
                    sprite: am5.Label.new(root, {
                        text: "{valueY}",
                        fill: theme === 'dark' ? am5.color(color) : am5.color(color),
                        stroke: root.interfaceColors.get("alternativeBackground"),
                        // centerY: am5.percent(50),
                        // centerX: am5.percent(50),
                        dy: -35,
                        dx: -15,
                        populateText: true,
                        fontSize: 16,
                        fontFamily: 'Roboto-Medium',
                        fontWeight: "bold", // Metni kalın yapar
                    })
                });
            });

            seriesBullet.strokes.template.setAll({
                strokeWidth: 2 // Çizginin kalınlığı, piksel cinsinden
            });

            seriesBullet.data.setAll(data);
            seriesBullet.appear();
            legend.data.push(seriesBullet);
        }

        cursor.events.on("cursormoved", function (ev) {
            // let dataItems = [];
            // let dataContext = seriesBar.get("tooltip").dataItem.dataContext;
            const category = xAxis.get("tooltip").dataItem.dataContext.period;
            const foundItem = lodash.find(data, { period: category });


            seriesBullet.set("tooltipHTML", createTooltipHTML(foundItem));

        });

        //#endregion BULLET  Pareto SERIES

        if (dividendAnalysisType === 'analysis') {
            makeSeries("Önceki Yıl Toplam Kar", "totalYieldPrevYear", "#1C5AE5");
            makeSeries("Toplam Temettü Tutarı", "totalDividend", "#EDB618");
            makeBulletsSeries("Önceki Yıl Temettü Dağıtım Oranı", "dividendPayoutRatio", "#A70202");
        }
        else if (dividendAnalysisType === 'amaount') {
            makeSeries("Toplam Temetü Tutarı", "dividendAmount", "#1C5AE5");
            makeBulletsSeries("Net Temettü Verimi (%)", "dividendYieldRatio", "#A70202");
        }
    }


    const createTooltipHTML = (data) => {

        // Temaya göre renkleri ayarlayın
        const blueColor = theme === 'dark' ? '#1c5ae5' : '#1c5ae5';
        const yellowColor = theme === 'dark' ? '#edb618' : '#edb618';
        const greenColor = theme === 'dark' ? '#2FBC99' : '#2FBC99';
        const redColor = theme === 'dark' ? '#a70202' : '#a70202';
        const volumeColor = theme === 'dark' ? '#67b7dc' : '#67b7dc';
        const backgroundColor = theme === 'dark' ? '#121212' : '#FFFFFF';
        const textColor = theme === 'dark' ? '#fff' : '#231f20';
        const textGray = theme === 'dark' ? '#FFFFFF' : '#757575';
        const period = data.period;
        const totalYieldPrevYear = numberFormatter.Double(data.totalYieldPrevYear, 2);
        const totalDividend = numberFormatter.Double(data.totalDividend, 2);
        const dividendAmount = numberFormatter.Double(data.dividendAmount, 2);

        if (dividendAnalysisType === 'analysis') {
            return `
            <div style="font-size:16px; font-family:Roboto-Medium; padding: 5px; background-color: ${backgroundColor}; color:  ${textColor}; border-radius: 5px; min-width: auto; border:.5px solid #b5b5b5">
          
            <div style="color:${greenColor};font-size:16px; font-family:Roboto-Bold;" > Yıl: ${period} </div>           

          
            <span style=" font-size:16px; font-family:Roboto-Medium; background-color: ${blueColor}; width: 10px; height: 10px; border-radius: 50%; display: inline-block;"></span>
            <span style=" font-size:16px; font-family:Roboto-Medium;">Önceki Yıl Toplam Kar: </span>   <label style="display:block; text-align:right; float:right; margin:0;  padding-left:10px;  font-size:16px; font-family:Roboto-Medium" > ${totalYieldPrevYear} mTL</label>
            </br>

            <span style=" font-size:16px; font-family:Roboto-Medium; background-color: ${yellowColor}; width: 10px; height: 10px; border-radius: 50%; display: inline-block;"></span>
            <span style=" font-size:16px; font-family:Roboto-Medium;">Toplam Temettü Tutarı: </span>   <label style="display:block; text-align:right; float:right; margin:0;  padding-left:10px;  font-size:16px; font-family:Roboto-Medium" > ${totalDividend} mTL</label>
            </br>

            <span style=" font-size:16px; font-family:Roboto-Medium; background-color: ${redColor}; width: 10px; height: 10px; border-radius: 50%; display: inline-block;"></span>
            <span style=" font-size:16px; font-family:Roboto-Medium;">Önceki Yıl Temettü Dağıtım Oranı: </span>   <label style="display:block; text-align:right; float:right; margin:0;  padding-left:10px;  font-size:16px; font-family:Roboto-Medium" > ${data.dividendPayoutRatio} % </label>
            </br>
               
            </div>`;
        }
        else if (dividendAnalysisType === 'amaount') {

            return `
            <div style="font-size:16px; font-family:Roboto-Medium; padding: 5px; background-color: ${backgroundColor}; color:  ${textColor}; border-radius: 5px; min-width: auto; border:.5px solid #b5b5b5">
          
            <div style="color:${greenColor};font-size:16px; font-family:Roboto-Bold;" > Yıl: ${period} </div>           

          
            <span style=" font-size:16px; font-family:Roboto-Medium; background-color: ${blueColor}; width: 10px; height: 10px; border-radius: 50%; display: inline-block;"></span>
            <span style=" font-size:16px; font-family:Roboto-Medium;">Toplam Temetü Tutarı: </span>   <label style="display:block; text-align:right; float:right; margin:0;  padding-left:10px;  font-size:16px; font-family:Roboto-Medium" > ${dividendAmount} mTL </label>
            </br>

            <span style=" font-size:16px; font-family:Roboto-Medium; background-color: ${redColor}; width: 10px; height: 10px; border-radius: 50%; display: inline-block;"></span>
            <span style=" font-size:16px; font-family:Roboto-Medium;">Net Temettü Verimi: </span>   <label style="display:block; text-align:right; float:right; margin:0;  padding-left:10px;  font-size:16px; font-family:Roboto-Medium" > ${data.dividendYieldRatio} % </label>
            </br>
               
            </div>`;

        }
    }

    //#region API CALLS 

    const populateChartData = () => {

        setSelectedEquity(props.symbol.code);
        api.apiDividendDataforgraphGet(token, props.symbol.code).then((res) => {
            // console.log('apiDividendDataforgraphGet: ', res);
            let data = res.data.data;
            for (let i = 0; i < data.length; i++) {
                let element = data[i];
                element.totalYieldPrevYear = element.totalYieldPrevYear == "NaN" ? 0 : numberFormatter.millionShort(element.totalYieldPrevYear, 2); // Önceki Yıl Toplam Kar
                element.totalDividend = element.totalDividend == "NaN" ? 0 : numberFormatter.millionShort(element.totalDividend, 2);// Toplam Temettü Tutarı 
                element.dividendPayoutRatio = element.dividendPayoutRatio == "NaN" ? 0 : numberFormatter.doubleNumber(element.dividendPayoutRatio, 2);
                element.totalYield = element.totalYield == "NaN" ? 0 : element.totalYield;
                element.dividendPayoutRatioPrevYear = element.dividendPayoutRatioPrevYear == "NaN" ? 0 : element.dividendPayoutRatioPrevYear;
            }
            setChartData(res.data);

        }).catch((err) => {

            // console.log(err);
        });

        api.apiDividendDataforgraph2Get(token, props.symbol.code).then((res) => {
            // console.log('apiDividendDataforgraph2Get: ', res);
            let data = res.data.data;

            for (let i = 0; i < data.length; i++) {
                let element = data[i];
                element.dividendAmount = element.dividendAmount == "NaN" ? 0 : numberFormatter.millionShort(element.dividendAmount, 2);
                element.dividendYieldRatio = element.dividendYieldRatio == "NaN" ? 0 : numberFormatter.doubleNumber(element.dividendYieldRatio, 2);

                // element.totalYieldPrevYear = element.totalYieldPrevYear == "NaN" ? 0 : numberFormatter.millionShort(element.totalYieldPrevYear, 2); // Önceki Yıl Toplam Kar
                // element.totalDividend = element.totalDividend == "NaN" ? 0 : numberFormatter.millionShort(element.totalDividend, 2);// Toplam Temettü Tutarı 
                // element.dividendPayoutRatio = element.dividendPayoutRatio == "NaN" ? 0 : numberFormatter.doubleNumber(element.dividendPayoutRatio, 2);
                // element.totalYield = element.totalYield == "NaN" ? 0 : element.totalYield;
                // element.dividendPayoutRatioPrevYear = element.dividendPayoutRatioPrevYear == "NaN" ? 0 : element.dividendPayoutRatioPrevYear;
            }
            setChartDataTwo(res.data);

        }).catch((err) => {
            // console.log(err);
        });
    }

    //#endregion API CALLS

    return (
        <div className='dividend-calendar-modal'>
            <Modal show={visible} onHide={handleClose}
                className='dividendAnalysisModal'
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header className='dividendAnalysisModalHeader'>
                    {/* <Modal.Title>Modal heading</Modal.Title> */}
                    <Container className='container'>
                        <Row className='columnsSelectHeaderRow cursor-pointer'>
                            <Col md="3" className=''>

                            </Col>
                            <Col md="6" className='dividendAnalysisTypeDiv'>
                                <Button className={[`dividendAnalysisTypeBtn roboto-medium-14 ${dividendAnalysisType === "analysis" ? "active" : "none"}`]} onClick={(e) => dividendAnalysisTypeChange('analysis')}>{selectedEquity} Kar ve Temettü Analizi</Button>
                                <Button className={[`dividendAnalysisTypeBtn roboto-medium-14 ${dividendAnalysisType === 'amaount' ? 'active' : ''}`]} onClick={(e) => dividendAnalysisTypeChange('amaount')}>{selectedEquity} Tarihsel Temettü Oran ve Miktar Grafiği</Button>
                            </Col>
                            <Col md="3"><FontAwesomeIcon className='modalCloseIcon text-align-right float-right cursor-pointer' icon={faCircleXmark} onClick={handleClose} /></Col>
                        </Row>
                    </Container>
                </Modal.Header>

                <Modal.Body className='dividendAnalysisModalBody'>


                    <Container className='modalBodyContainer'>
                        <Row>
                            <div id="chartdiv" style={{ width: "100%", height: "600px" }}></div>
                            {/* 
                            <Col className={[`charts-div ${dividendAnalysisType === "analysis" ? "d-block" : "d-none"}`]}>
                            </Col> */}

                            {/* <Col className={[`charts-div ${dividendAnalysisType === "amaount" ? "d-block" : "d-none"}`]}>
                                <div id="chartdivtwo" style={{ width: "100%", height: "600px" }}></div>
                            </Col> */}

                        </Row>
                    </Container>

                </Modal.Body>
                <Modal.Footer className='dividendAnalysisModalFooter' hidden={true}>

                    <Container>
                        <Row>
                            <Col md='12'>
                                <Button className='dividendAnalysisModalSaveButton roboto-bold-17' variant="primary" onClick={handleClose}>
                                    Kaydet
                                </Button>
                            </Col>
                        </Row>
                    </Container>

                </Modal.Footer>
            </Modal>

        </div>
    )
}

export default DividendGraphs;
